const CALL_CENTER_WORKING_TIME = {
  1: {
    start: '08:00',
    end: '20:00',
  },
  2: {
    start: '08:00',
    end: '20:00',
  },
  3: {
    start: '08:00',
    end: '20:00',
  },
  4: {
    start: '08:00',
    end: '20:00',
  },
  5: {
    start: '08:00',
    end: '20:00',
  },
  6: {
    start: '08:00',
    end: '18:30',
  },
};

/**
 * Converts a time string in format "HH:mm" to total minutes
 * @param {string} timeStr - Time string in format "HH:mm"
 * @returns {number} Total minutes
 */
const timeToMinutes = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};

const isWithinCallCenterWorkingHours = (date) => {
  // Get the day of the week (1-7, where 1 is Monday)
  const dayOfWeek = date.getDay() || 7; // Convert Sunday (0) to 7

  // Check if the day is in the working schedule
  const daySchedule = CALL_CENTER_WORKING_TIME[dayOfWeek];
  if (!daySchedule) {
    return false;
  }

  // Get current time in HH:mm format
  const currentTime = date.toLocaleTimeString('it-IT', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
  });

  // Convert all times to minutes for comparison
  const currentMinutes = timeToMinutes(currentTime);
  const startMinutes = timeToMinutes(daySchedule.start);
  const endMinutes = timeToMinutes(daySchedule.end);

  // Compare with working hours
  return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
};

export default isWithinCallCenterWorkingHours;
